import React from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'

import { Flex, P, Image, Grid } from 'ui/bend'

import { ResponsiveSVG } from 'ui/acro'
import { AlomovesIconSVG } from 'images/latest'
import { useUserContext } from 'context'
import { storeEventInLocalStorage } from 'gtm/pushEvents'

export const CardCTAText = styled(P)(() =>
  css({
    fontSize: '18px',
    letterSpacing: '0.9px',
    textTransform: 'uppercase',
    marginTop: '7px',
    fontWeight: '500',
    lineHeight: '24px'
  })
)

const ItemContainer = styled(Flex)`
  width: 100%;
  max-width: 100%;
  padding-top: 56.25%;
`

const CardSummarySection = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  p {
    font-size: 16px;
  }
  a {
    flex: 1 0 40%;
  }
  @media screen and (min-width: 764px) {
    gap: 20px;
    p {
      font-size: 18px;
    }
    a {
      flex: 1 0 20%;
    }
  }

  .no-thumbnail {
    position: absolute;
    margin-top: -56.25%;
    width: fit-content;
    height: 70%;
  }
`

const MyPraticeCard = ({ data, keyName }) => {
  const textObject = {
    completedClasses: 'Completed',
    playlists: 'My Playlists',
    savedClasses: 'Saved Classes',
    savedSeries: 'Saved Series'
  }

  const linkObject = {
    completedClasses: 'completed',
    playlists: 'playlists',
    savedClasses: 'classes',
    savedSeries: 'series'
  }

  const count = data?.[keyName]?.count
  const lastThumbnail = data?.[keyName]?.lastThumbnail

  const handleClick = (tab) => {
    const eventMap = {
      series: 'saved_series_click',
      classes: 'saved_classes_click',
      completed: 'completed_classes_click',
      playlists: 'my_playlists_click'
    }

    storeEventInLocalStorage({ event: eventMap[tab], location: 'homepage' })
  }

  const thumbnailPresent = count > 0 && !!lastThumbnail

  return (
    <a
      href={`/my/practice?tab=${linkObject?.[keyName]}`}
      onClick={() => {
        handleClick(linkObject?.[keyName]?.toLowerCase())
      }}
      className={keyName}
    >
      <ItemContainer
        aspectRatio='16/9'
        {...(thumbnailPresent
          ? {
              backgroundImage: `url(${lastThumbnail})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }
          : {
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#F2F2F2',
              position: 'relative'
            })}
      >
        {!thumbnailPresent && (
          <ResponsiveSVG
            width={['68px', '68px', '130px', '130px']}
            height={['68px', '68px', '130px', '130px']}
            SVG={AlomovesIconSVG}
            className='no-thumbnail'
          />
        )}
      </ItemContainer>
      <CardCTAText>{`${textObject[keyName]} (${count})`}</CardCTAText>
    </a>
  )
}

export const MyPraticeCards = () => {
  const { user } = useUserContext()
  return (
    <CardSummarySection>
      <MyPraticeCard
        data={user?.myPracticeSnapshot?.details}
        keyName={'completedClasses'}
      />

      <MyPraticeCard
        data={user?.myPracticeSnapshot?.details}
        keyName={'savedClasses'}
      />

      <MyPraticeCard
        data={user?.myPracticeSnapshot?.details}
        keyName={'savedSeries'}
      />

      <MyPraticeCard
        data={user?.myPracticeSnapshot?.details}
        keyName={'playlists'}
      />
    </CardSummarySection>
  )
}
